import { render, staticRenderFns } from "./DeliverFrom.vue?vue&type=template&id=84a40ab6&scoped=true&"
import script from "./DeliverFrom.vue?vue&type=script&lang=js&"
export * from "./DeliverFrom.vue?vue&type=script&lang=js&"
import style0 from "./DeliverFrom.vue?vue&type=style&index=0&id=84a40ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a40ab6",
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QChip});
